// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InferredFieldsBuilder_container__Actn6 {
  margin: 15px 0px;
  padding: 16px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.InferredFieldsBuilder_container__Actn6:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.InferredFieldsBuilder_title__\\+khnt {
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
  background-color: transparent;
  padding: 0;
  border-radius: 0;
}

.InferredFieldsBuilder_emptyMessage__ME2No {
  color: #6c757d;
  margin-top: 8px;
  font-size: 0.813rem;
  font-style: italic;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  text-align: center;
}

.InferredFieldsBuilder_fieldRow__ajeqi {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.InferredFieldsBuilder_fieldRow__ajeqi:hover {
  border-color: #dee2e6;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.InferredFieldsBuilder_fieldNameWrapper__Jkx7U {
  flex: 1 1 120px;
  min-width: 100px;
}

.InferredFieldsBuilder_fieldLabelWrapper__1IpQ4 {
  flex: 1 1 150px;
  min-width: 120px;
}

.InferredFieldsBuilder_fieldTypeWrapper__KlIUw {
  flex: 1 1 110px;
  min-width: 100px;
  position: relative;
}

.InferredFieldsBuilder_fieldFormatWrapper__k42YK {
  flex: 1 1 160px;
  min-width: 130px;
  position: relative;
}

.InferredFieldsBuilder_fieldRequiredWrapper__wWPxH {
  flex: 0 0 auto;
  padding-top: 18px;
}

.InferredFieldsBuilder_fieldPlaceholderWrapper__P1pd4 {
  flex: 1 1 150px;
  min-width: 120px;
}

.InferredFieldsBuilder_fieldLabel__rDaNa {
  display: block;
  font-size: 0.688rem;
  font-weight: 600;
  margin-bottom: 4px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.InferredFieldsBuilder_fieldInput__AIVzU {
  width: 100%;
  padding: 6px 8px;
  font-size: 0.813rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  transition: all 0.2s ease;
  background-color: #ffffff;
}

.InferredFieldsBuilder_fieldInput__AIVzU:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.InferredFieldsBuilder_readOnlyInput__9nUlN {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  border-color: #dee2e6;
}

.InferredFieldsBuilder_disabledInput__DKZYw {
  background-color: #f8f9fa;
  cursor: not-allowed;
  opacity: 0.7;
}

.InferredFieldsBuilder_fieldSelect__swe2k {
  width: 100%;
  padding: 6px 8px;
  font-size: 0.813rem;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #ffffff;
  transition: all 0.2s ease;
}

.InferredFieldsBuilder_fieldSelect__swe2k:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.InferredFieldsBuilder_fieldSelect__swe2k:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
}

.InferredFieldsBuilder_checkboxLabel__xT26i {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.813rem;
  color: #495057;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.InferredFieldsBuilder_checkbox__RgRIM {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--saveBtn);
  color: var(--white-color);
}

.InferredFieldsBuilder_checkbox__RgRIM:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* ------------------------------------------------------------------
   Type/Format label info icon + tooltip
   ------------------------------------------------------------------ */

/* Wrapper for the little ⓘ icon next to the "Type" or "Format" label */
.InferredFieldsBuilder_infoIconWrapper__ZiGuX {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: help;
  color: #667eea;
  margin-left: 2px;
}

.InferredFieldsBuilder_infoIconWrapper__ZiGuX:hover {
  color: #4c5bd4;
}

/* The hover panel itself. Positioned above the icon, centred,
   and given a fixed width so long descriptions wrap predictably. */
.InferredFieldsBuilder_typeTooltip__XS0W\\+ {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #2d3748;
  color: #ffffff;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 11px;
  width: 260px;
  text-align: left;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  line-height: 1.5;
  text-transform: none;
  letter-spacing: normal;
  font-weight: 400;
  pointer-events: none;
}

/* Small title inside the tooltip */
.InferredFieldsBuilder_typeTooltipTitle__8OORg {
  display: block;
  margin-bottom: 4px;
  color: #90cdf4;
  font-weight: 600;
}

/* Divider + small table of type → description */
.InferredFieldsBuilder_typeTooltipTypes__8hyYf {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #4a5568;
  font-size: 10px;
  color: #cbd5e0;
}

.InferredFieldsBuilder_typeTooltipRow__7ijv2 {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
}

.InferredFieldsBuilder_typeTooltipCode__yLTE8 {
  color: #f6ad55;
  font-family: monospace;
  font-size: 10px;
  flex-shrink: 0;
}

.InferredFieldsBuilder_typeTooltipDesc__83XAB {
  flex: 1 1;
  text-align: right;
  color: #a0aec0;
}

/* Little arrow pointing at the icon */
.InferredFieldsBuilder_typeTooltipArrow__y\\+zKC {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #2d3748;
}

/* Inline code inside tooltips (e.g. sample format values) */
.InferredFieldsBuilder_typeTooltipCodeInline__fPbIR {
  color: #f6ad55;
  font-family: monospace;
  background: rgba(246, 173, 85, 0.1);
  padding: 1px 4px;
  border-radius: 3px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .InferredFieldsBuilder_container__Actn6 {
    padding: 12px;
  }

  .InferredFieldsBuilder_fieldRow__ajeqi {
    flex-direction: column;
    gap: 10px;
    padding: 12px;
  }

  .InferredFieldsBuilder_fieldNameWrapper__Jkx7U,
  .InferredFieldsBuilder_fieldLabelWrapper__1IpQ4,
  .InferredFieldsBuilder_fieldTypeWrapper__KlIUw,
  .InferredFieldsBuilder_fieldFormatWrapper__k42YK,
  .InferredFieldsBuilder_fieldPlaceholderWrapper__P1pd4 {
    flex: 1 1 auto;
    width: 100%;
  }

  .InferredFieldsBuilder_fieldRequiredWrapper__wWPxH {
    padding-top: 0;
    width: 100%;
  }

  .InferredFieldsBuilder_checkboxLabel__xT26i {
    justify-content: flex-start;
  }

  /* On mobile the tooltip would overflow the narrow column;
     pin it to the left edge and let it grow right. */
  .InferredFieldsBuilder_typeTooltip__XS0W\\+ {
    left: 0;
    transform: none;
    width: min(240px, 90vw);
  }

  .InferredFieldsBuilder_typeTooltipArrow__y\\+zKC {
    left: 18px;
    transform: none;
  }
}

/* Animation for new fields */
@keyframes InferredFieldsBuilder_fadeIn__6lqFR {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.InferredFieldsBuilder_fieldRow__ajeqi {
  animation: InferredFieldsBuilder_fadeIn__6lqFR 0.2s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/InferredFieldsBuilder.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;uEAEuE;;AAEvE,uEAAuE;AACvE;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;mEACmE;AACnE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;;;;;IAKE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;qDACmD;EACnD;IACE,OAAO;IACP,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,4DAA+B;AACjC","sourcesContent":[".container {\n  margin: 15px 0px;\n  padding: 16px;\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  transition: all 0.3s ease;\n}\n\n.container:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.title {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.875rem;\n  background-color: transparent;\n  padding: 0;\n  border-radius: 0;\n}\n\n.emptyMessage {\n  color: #6c757d;\n  margin-top: 8px;\n  font-size: 0.813rem;\n  font-style: italic;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  text-align: center;\n}\n\n.fieldRow {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n  transition: all 0.2s ease;\n}\n\n.fieldRow:hover {\n  border-color: #dee2e6;\n  background-color: #ffffff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.fieldNameWrapper {\n  flex: 1 1 120px;\n  min-width: 100px;\n}\n\n.fieldLabelWrapper {\n  flex: 1 1 150px;\n  min-width: 120px;\n}\n\n.fieldTypeWrapper {\n  flex: 1 1 110px;\n  min-width: 100px;\n  position: relative;\n}\n\n.fieldFormatWrapper {\n  flex: 1 1 160px;\n  min-width: 130px;\n  position: relative;\n}\n\n.fieldRequiredWrapper {\n  flex: 0 0 auto;\n  padding-top: 18px;\n}\n\n.fieldPlaceholderWrapper {\n  flex: 1 1 150px;\n  min-width: 120px;\n}\n\n.fieldLabel {\n  display: block;\n  font-size: 0.688rem;\n  font-weight: 600;\n  margin-bottom: 4px;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.fieldInput {\n  width: 100%;\n  padding: 6px 8px;\n  font-size: 0.813rem;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n  background-color: #ffffff;\n}\n\n.fieldInput:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.readOnlyInput {\n  background-color: #e9ecef;\n  color: #6c757d;\n  cursor: not-allowed;\n  border-color: #dee2e6;\n}\n\n.disabledInput {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.fieldSelect {\n  width: 100%;\n  padding: 6px 8px;\n  font-size: 0.813rem;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  background-color: #ffffff;\n  transition: all 0.2s ease;\n}\n\n.fieldSelect:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.fieldSelect:disabled {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.813rem;\n  color: #495057;\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkbox {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: var(--saveBtn);\n  color: var(--white-color);\n}\n\n.checkbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* ------------------------------------------------------------------\n   Type/Format label info icon + tooltip\n   ------------------------------------------------------------------ */\n\n/* Wrapper for the little ⓘ icon next to the \"Type\" or \"Format\" label */\n.infoIconWrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  cursor: help;\n  color: #667eea;\n  margin-left: 2px;\n}\n\n.infoIconWrapper:hover {\n  color: #4c5bd4;\n}\n\n/* The hover panel itself. Positioned above the icon, centred,\n   and given a fixed width so long descriptions wrap predictably. */\n.typeTooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #2d3748;\n  color: #ffffff;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-size: 11px;\n  width: 260px;\n  text-align: left;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n  line-height: 1.5;\n  text-transform: none;\n  letter-spacing: normal;\n  font-weight: 400;\n  pointer-events: none;\n}\n\n/* Small title inside the tooltip */\n.typeTooltipTitle {\n  display: block;\n  margin-bottom: 4px;\n  color: #90cdf4;\n  font-weight: 600;\n}\n\n/* Divider + small table of type → description */\n.typeTooltipTypes {\n  margin-top: 8px;\n  padding-top: 6px;\n  border-top: 1px solid #4a5568;\n  font-size: 10px;\n  color: #cbd5e0;\n}\n\n.typeTooltipRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.typeTooltipCode {\n  color: #f6ad55;\n  font-family: monospace;\n  font-size: 10px;\n  flex-shrink: 0;\n}\n\n.typeTooltipDesc {\n  flex: 1;\n  text-align: right;\n  color: #a0aec0;\n}\n\n/* Little arrow pointing at the icon */\n.typeTooltipArrow {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #2d3748;\n}\n\n/* Inline code inside tooltips (e.g. sample format values) */\n.typeTooltipCodeInline {\n  color: #f6ad55;\n  font-family: monospace;\n  background: rgba(246, 173, 85, 0.1);\n  padding: 1px 4px;\n  border-radius: 3px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .container {\n    padding: 12px;\n  }\n\n  .fieldRow {\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px;\n  }\n\n  .fieldNameWrapper,\n  .fieldLabelWrapper,\n  .fieldTypeWrapper,\n  .fieldFormatWrapper,\n  .fieldPlaceholderWrapper {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n\n  .fieldRequiredWrapper {\n    padding-top: 0;\n    width: 100%;\n  }\n\n  .checkboxLabel {\n    justify-content: flex-start;\n  }\n\n  /* On mobile the tooltip would overflow the narrow column;\n     pin it to the left edge and let it grow right. */\n  .typeTooltip {\n    left: 0;\n    transform: none;\n    width: min(240px, 90vw);\n  }\n\n  .typeTooltipArrow {\n    left: 18px;\n    transform: none;\n  }\n}\n\n/* Animation for new fields */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fieldRow {\n  animation: fadeIn 0.2s ease-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InferredFieldsBuilder_container__Actn6`,
	"title": `InferredFieldsBuilder_title__+khnt`,
	"emptyMessage": `InferredFieldsBuilder_emptyMessage__ME2No`,
	"fieldRow": `InferredFieldsBuilder_fieldRow__ajeqi`,
	"fieldNameWrapper": `InferredFieldsBuilder_fieldNameWrapper__Jkx7U`,
	"fieldLabelWrapper": `InferredFieldsBuilder_fieldLabelWrapper__1IpQ4`,
	"fieldTypeWrapper": `InferredFieldsBuilder_fieldTypeWrapper__KlIUw`,
	"fieldFormatWrapper": `InferredFieldsBuilder_fieldFormatWrapper__k42YK`,
	"fieldRequiredWrapper": `InferredFieldsBuilder_fieldRequiredWrapper__wWPxH`,
	"fieldPlaceholderWrapper": `InferredFieldsBuilder_fieldPlaceholderWrapper__P1pd4`,
	"fieldLabel": `InferredFieldsBuilder_fieldLabel__rDaNa`,
	"fieldInput": `InferredFieldsBuilder_fieldInput__AIVzU`,
	"readOnlyInput": `InferredFieldsBuilder_readOnlyInput__9nUlN`,
	"disabledInput": `InferredFieldsBuilder_disabledInput__DKZYw`,
	"fieldSelect": `InferredFieldsBuilder_fieldSelect__swe2k`,
	"checkboxLabel": `InferredFieldsBuilder_checkboxLabel__xT26i`,
	"checkbox": `InferredFieldsBuilder_checkbox__RgRIM`,
	"infoIconWrapper": `InferredFieldsBuilder_infoIconWrapper__ZiGuX`,
	"typeTooltip": `InferredFieldsBuilder_typeTooltip__XS0W+`,
	"typeTooltipTitle": `InferredFieldsBuilder_typeTooltipTitle__8OORg`,
	"typeTooltipTypes": `InferredFieldsBuilder_typeTooltipTypes__8hyYf`,
	"typeTooltipRow": `InferredFieldsBuilder_typeTooltipRow__7ijv2`,
	"typeTooltipCode": `InferredFieldsBuilder_typeTooltipCode__yLTE8`,
	"typeTooltipDesc": `InferredFieldsBuilder_typeTooltipDesc__83XAB`,
	"typeTooltipArrow": `InferredFieldsBuilder_typeTooltipArrow__y+zKC`,
	"typeTooltipCodeInline": `InferredFieldsBuilder_typeTooltipCodeInline__fPbIR`,
	"fadeIn": `InferredFieldsBuilder_fadeIn__6lqFR`
};
export default ___CSS_LOADER_EXPORT___;
